import api from '../token';

export const AlterConta = async (dados) => {
  try {
    const response = await api.post('/alterConta', dados);
    return response.data;
  } catch (error) {
   
    return [];
  }
};

